import React, { useContext } from 'react';
import {
	FormImageUploaderNewContext,
	IFormImageUploaderNewContext,
	IMaxFileSizeMB,
} from '../formImageUploaderNewState/formImageUploaderNewContext';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { FileSizeLabel } from './FileSizeLabel';
import Button from 'components/Button/Button';
import VideoUploaderByFilePath from 'components/VideoUploader/VideoUploaderByFilePath';
import Text from 'components/Text/Text';
import classNames from 'classnames';
import style from './Uploader.module.scss';

interface IProps {
	videoPath: string;
	containerClass?: string;
	deleteVideoHandler?: () => void;
	maxFileSizeMB: IMaxFileSizeMB;
}

export const VideoCard: React.FC<IProps> = ({ videoPath, containerClass, deleteVideoHandler, maxFileSizeMB }) => {
	const { changeTypeOfModalWindow, committedVideoSrc } =
		useContext<IFormImageUploaderNewContext>(FormImageUploaderNewContext);

	const containerClasses = classNames(style.container, containerClass);

	const openMediaModal = () => {
		changeTypeOfModalWindow('cropper');
	};

	return (
		<div className={containerClasses} data-test="VideoCard">
			<div className={style.renderImageWrapper}>
				<div className={style.imageContainer}>
					{committedVideoSrc ? (
						<video className={style.image} src={committedVideoSrc} controls={true} />
					) : (
						<VideoUploaderByFilePath filePath={videoPath} loaderSize="big" isShowControls={true} />
					)}
				</div>
			</div>
			<FileSizeLabel maxFileSizeMB={maxFileSizeMB.video} />
			<div className={style.buttonsWrapper}>
				<Button
					className={style.button}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#reload`} />
						</svg>
					}
					onClick={openMediaModal}
					data-test="replaceVideoButton">
					<Text translationNameSpace="form" translationKey="replaceVideoButton" asFragment={true} />
				</Button>
				<Button
					className={classNames(style.deleteButton, style.buttonVisible)}
					theme="secondary"
					icon={
						<svg className={classNames(style.icon, style.deleteIcon)}>
							<use xlinkHref={`${breadcrumbs}#bin`} />
						</svg>
					}
					onClick={deleteVideoHandler}
					data-test="deleteVideoButton">
					<Text translationNameSpace="form" translationKey="deleteVideoButton" asFragment={true} />
				</Button>
			</div>
		</div>
	);
};
